module.exports = __webpack_public_path__ + "assets/img/tjgg.0357e92b.png";